/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Job } from './Job';
const ExtendedJobParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['kwargs', /* #__PURE__ */ codec.record(codecString, codec.unknown)],
    ['tryN', codecNumber, 'try_n'],
    ['eta', parsers.moment],
    ['traceback', /* #__PURE__ */ parsers.maybeNull(codecString)],
]), Job);
export class ExtendedJob extends Job {
    static decode(input) {
        return ExtendedJobParser.decode(input).map(res => new ExtendedJob(res));
    }
    static unsafeDecode(input) {
        return ExtendedJob.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedJobParser.encode(data);
    }
    static schema() {
        return ExtendedJobParser.schema();
    }
}
